module.exports = __webpack_public_path__ + "img/ic_bill_to_org_payment-method-light.33627d6.svg";